import { ContractStatus } from '@/pages/ContractSearchPage/types'

export type Contract = {
  header: ContractHeader
  masterData: ContractMasterData
  tariffBookings: ContractTariffBookings
}

export type ContractHeader = {
  contractNumber: string
  contractType: ContractType
  contractStatus: ContractStatus
  billingAccountId?: string
  businessPartnerIdExternal?: string
  myEnergyKeySubject?: string
  legacyEndUserId: number
}

export type ContractMasterData = {
  keyFigures: ContractKeyFigures
  contractDetails: ContractDetails
  contractPartner: ContractPartner
  billingAddress: ContractBillingAddress
}

export type ContractKeyFigures = {
  emaId: string
  billingAccountIdExternal?: string
}

export type ContractDetails = {
  contractNumber: string
  contractType: ContractType
  createdAt: Date
  createdByType: ContractCreatorType
}

export type ContractPartner = {
  salutation: Salutation
  firstName: string
  lastName: string
  birthday?: Date
  email: string
  phoneNumber?: string
  alternativePhoneNumber?: string
}

export type ContractBillingAddress = {
  street: string
  houseNumber?: string
  postalCode: string
  city: string
  country: string
}

export type ContractTariffBookings = {
  pastTariffBookings: ContractTariffBooking[]
  currentTariffBooking: ContractTariffBooking | undefined
  futureTariffBooking: ContractTariffBooking | undefined
}

export type ContractTariffBooking = {
  tariffId: number
  tariffName: string
  bookedAt: Date
  validFrom: Date
  validUntil?: Date
  salesPartnerName?: SalesPartnerName
  salesPartnerCustomerReferenceId?: string
}

export enum ContractType {
  B2C = 'B2C',
  B2B = 'B2B',
  UNSPECIFIED = 'UNSPECIFIED'
}

export enum Salutation {
  MR = 'MR',
  MS = 'MS',
  MX = 'MX',
  UNKNOWN = 'UNKNOWN'
}

export enum ContractCreatorType {
  CUSTOMER = 'CUSTOMER',
  SUPPORT = 'SUPPORT',
  SYSTEM = 'SYSTEM'
}

export enum SalesPartnerName {
  ACE = 'ACE',
  ACV = 'ACV',
  ADAC = 'ADAC',
  ALLIANZ = 'ALLIANZ',
  ENBW_COMMODITY = 'ENBW_COMMODITY',
  ENMA = 'ENMA',
  HYUNDAI = 'HYUNDAI',
  LBBW = 'LBBW',
  MOVE = 'MOVE',
  YELLO = 'YELLO'
}
